import axios from "axios";
import { cultureCheck } from "../utils/utils";
import ResponseData from "../types/types";

const url = new URL(window.location.href);

const API_URL = `${url.origin}/api-v2`;

const API_URL_LIST = `${API_URL}/list`;

export async function getListByInput(data: {
  url: string;
  payload: any;
}): Promise<ResponseData> {
  try {
    const form: FormData = new FormData();
    form.append("filter", data.payload.filter);
    form.append("list", data.payload.list);
    form.append("language", cultureCheck().toUpperCase());
    const url: string = `${API_URL_LIST}/${data.url}`;
    const response : any = axios.post(url, form);
    return response;
  } catch (error) {
    throw new Error(`Error fetching list by input: ${error}`);
  }
}
const defaultLogoPath = '/wp-content/themes/euclaim/img/airlineLogo/default.svg';

const checkImageExists = (url: string, callback: (exists: boolean) => void) => {
  const img = new Image();
  img.onload = () => callback(true);
  img.onerror = () => {
    callback(false);
    img.onerror = () => {};
  };
  img.src = url;
};

const getFlightLogoPath = async (airlineCode: string): Promise<string> => {
  const logoPath = `/wp-content/themes/euclaim/img/airlineLogo/${airlineCode}.svg`;
  const exists = await new Promise<boolean>(resolve => checkImageExists(logoPath, resolve));
  return exists ? logoPath : defaultLogoPath;
};

export async function getProblemFlightsFromAPI(data: {
  url: string;
  payload: any;
}): Promise<ResponseData> {
  try {
    const form: FormData = new FormData();
    form.append("date", data.payload.date);
    form.append("airlineCode", data.payload.airlineCode);
    form.append("airportCode", data.payload.airportCode);
    form.append("culture", cultureCheck().toUpperCase());
    form.append("limit", data.payload.limit);

    const url: string = `${API_URL_LIST}/${data.url}`;
    const response: any = await axios.post(url, form);

    const flights = response.data;  

    const logos = await Promise.all(flights.map(async (flight: any) => {
      const logoPath = await getFlightLogoPath(flight?.AirlineCode);
      return { [flight?.AirlineCode]: logoPath };
    }));

    const flightLogoPaths = Object.assign({}, ...logos);

    flights.forEach((flight: any) => {
      flight.logoPath = flightLogoPaths[flight.AirlineCode];
    });

    return {
      ...response,
      data: flights
    };
  } catch (error) {
    throw new Error(`Error fetching Problem Flights by input: ${error}`);
  }
}